import { asBoolean, asNumber, asString, isObject } from "./model-utils";
import {
  enumValue,
  ProductNode,
  WeightType,
  WeightUnit,
} from "./enums";

export class PaymentItem {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.id = asString(json._id || json.id);
    this.productId = asString(json.productId);
    this.productNo = asString(json.productNo);
    this.name = asString(json.name);
    this.description = asString(json.description);
    this.amount = asNumber(json.amount);
    this.initialAmount = asNumber(json.initialAmount);
    this.unit = asNumber(json.unit);
    this.quantity = asNumber(json.quantity);
    this.returnedQuantity = asNumber(json.returnedQuantity);
    this.bookedQuantity = asNumber(json.bookedQuantity);
    this.deductedQuantity = asNumber(json.deductedQuantity);
    this.currency = asString(json.currency);
    this.cost = asNumber(json.cost);
    this.productCategoryId = asString(json.productCategoryId);
    this.productCategoryName = asString(json.productCategoryName);
    this.productSectionId = asString(json.productSectionId);
    this.productSectionName = asString(json.productSectionName);
    this.itemDescription = asString(json.itemDescription);
    this.extractedText = asString(json.extractedText);
    this.extractedPrice = asNumber(json.extractedPrice);
    this.itemIdentifier = asString(json.itemIdentifier);
    this.jobNo = asString(json.jobNo);
    this.pickUpAddress = asString(json.pickUpAddress);
    this.pickupCountry = asString(json.pickupCountry);
    this.pickUpCountryCode = asString(json.pickUpCountryCode);
    this.deliveryAddress = asString(json.deliveryAddress);
    this.deliveryCountry = asString(json.deliveryCountry);
    this.deliveryCountryCode = asString(json.deliveryCountryCode);
    this.trackingCollectionId = asString(json.trackingCollectionId);
    this.trackingOrderNo = asString(json.trackingOrderNo);
    this.printCount = asNumber(json.printCount);
    this.requestedUnit = asNumber(json.requestedUnit);
    this.requestedUpdate = asBoolean(json.requestedUpdate);
    this.reviewRequired = asBoolean(json.reviewRequired);
    this.reviewReason = asString(json.reviewReason);
    this.productDetection = asBoolean(json.productDetection);
    this.matchScore = asNumber(json.matchScore);
    this.total = asNumber(json.total);
    this.moqDetected = asBoolean(json.moqDetected);
    this.isVariant = asBoolean(json.isVariant);
    this.parentId = asString(json.parentId);
    this.node = enumValue(ProductNode, json.node);
    this.trackingStatus = asString(json.trackingStatus);
    this.trackingCount = asNumber(json.trackingCount);
    this.unlimited = asBoolean(json.unlimited);
    this.manualCompute = asBoolean(json.manualCompute);
    this.useDiscount = asBoolean(json.useDiscount);
    this.usePromo = asBoolean(json.usePromo);
    this.useMarkUp = asBoolean(json.useMarkUp);
    this.useCategoryDiscount = asBoolean(json.useCategoryDiscount);
    this.productDeducted = asBoolean(json.productDeducted);
    this.vatExclude = asBoolean(json.vatExclude);
    this.categoryDiscountName = asString(json.categoryDiscountName);
    this.categoryPercentage = asNumber(json.categoryPercentage);
    this.weight = asNumber(json.weight);
    this.weightCategoryId = asString(json.weightCategoryId);
    this.weightCategoryName = asString(json.weightCategoryName);
    this.weightUnit = enumValue(WeightUnit, json.weightUnit);
    this.weightType = enumValue(WeightType, json.weightType);
    this.isPackQuantity = asBoolean(json.isPackQuantity);
    this.packQuantity = asNumber(json.packQuantity);
    this.logisticsScopedProducts = asBoolean(json.logisticsScopedProducts);
  }

  static fromJson(json: any) {
    return isObject(json) ? new PaymentItem(json) : json;
  }
}
